import { createMark } from '@lcifr/portable';
import { Bleach } from './Bleach';

export const BleachMark = createMark('decoratorBleach', ({ children }) => {
  return <Bleach>{children}</Bleach>;
});
